/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { theme } from '../../../db.json';

import MenuProfile from '../../../components/MenuProfile/MenuProfile';
import LogoBackground from '../../../components/LogoBackground';
import { ContainerPages } from '../../../components/Containers';
import TemplateObrigacoesAcessoriasFiscal from '../../../templates/NovoSistema/Fiscal/ObrigacoesAcessorias/index';
import MenuBarPages from '../../../components/Home/MenuBar/MenuBarPages';
import ButtonMenuBar from '../../../components/Home/MenuBar/ButtonMenuBar';

export default function ObrigacoesAcessoriasFiscal(props) {
  const { userInfo } = useSelector((state) => state.userSign);
  const themeColors = theme.colors.systems;

  useEffect(() => {
    if (!userInfo) {
      props.history.push('/login');
    }
    if (userInfo !== null) {
      if (userInfo.accessMode === process.env.REACT_APP_ACCESSKEY_NEW_SYSTEM) {
        props.history.push(`/novo-sistema/fiscal/obrigacoes-acessorias`);
      } else {
        props.history.push('/login');
      }
    }
  }, [userInfo, props.history]);

  return (
    <ContainerPages>
      <MenuProfile />
      <MenuBarPages>
        <ButtonMenuBar
          name="Fiscal"
          color={themeColors.NS.Fiscal}
          icon="/images/icons/buttons/coins.svg"
          link="/novo-sistema/fiscal"
        />
        <ButtonMenuBar
          name="Obrigações Acessórias"
          border={themeColors.NS.Fiscal}
          active={true}
          icon="/images/icons/buttons/information.svg"
          link="/novo-sistema/fiscal/obrigacoes-acessorias"
        />
        <ButtonMenuBar
          name="Apuração Tributária"
          border={themeColors.NS.Fiscal}
          icon="/images/icons/buttons/moneyPaper.svg"
          link="/novo-sistema/fiscal/apuracao-tributaria"
        />
        <ButtonMenuBar
          name="CND"
          border={themeColors.NS.Fiscal}
          icon="/images/icons/buttons/cdn.svg"
          link="/novo-sistema/fiscal/cnd"
        />
      </MenuBarPages>
      <TemplateObrigacoesAcessoriasFiscal />
      <LogoBackground />
    </ContainerPages>
  );
}
